module.exports = __webpack_public_path__ + "static/c2-e3b89c727754f61786442092499544be.png";